// import reportLsList from '../components/reportLs/reportLsList.vue'

export default [
    { 
        path: 'reportLs/reportLsList', 
        component: resolve => require(['@/components/reportLs/reportLsList'],resolve),
        name:'ReportLsList',
        meta:{
            id:'831',
            node:'reportLs',
            url:'reportLsList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/reportLs.js